import React, {useMemo} from 'react';

import {maybePluralize} from '../../../util/uihelpers';
import {MultiMetricPanelsMap} from './hooks/useMultiMetricPanelsMap';
import {MultiMetricPanelsListItem} from './MultiMetricPanelsListItem';

type MultiMetricPanelsListProps = {
  panelsToAdd: MultiMetricPanelsMap;
};

export const MultiMetricPanelsList = ({
  panelsToAdd,
}: MultiMetricPanelsListProps) => {
  // Memoizing because panelsToAdd size could get quite large
  const panelRegexes = useMemo(() => {
    return Array.from(panelsToAdd.keys());
  }, [panelsToAdd]);
  return (
    <div>
      <p className="text-moon-800 font-semibold mb-8">
        {maybePluralize(panelsToAdd.size, 'panel')} will be added
      </p>
      <div className="ml-12 border-l-2 border-solid border-moon-250 pl-12">
        <div className="flex flex-col gap-8">
          {panelRegexes.map(panelRegex => {
            const panelToAdd = panelsToAdd.get(panelRegex);
            if (!panelToAdd) {
              return null;
            }
            return (
              <MultiMetricPanelsListItem
                key={panelRegex}
                regex={panelRegex}
                metrics={panelToAdd.metrics}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};
